import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import "url-search-params-polyfill"; // For IE11 & searchParams
// for Promises in IE11 I use the 'es6-promise.auto.min' library

const Ivs = props => {
  const eventUUID = props.uuid;
  const uuidCookieLifetime = props.uuidCookieLifetime;
  const analyticsDomain = props.domain + "/ex/live_analytics";

  const [isPublic, setIsPublic] = useState(true);
  const [playerOptions, setPlayerOptions] = useState({
    autoplay: true,
    fluid: true,
    liveui: false,
    controls: true,
    muted: true,
    controlBar: { fullscreenToggle: true, playToggle: true },
    html5: { hls: { withCredentials: false } },
  });
  const [liveEvent, setLiveEvent] = useState(props.live_event.data);
  const [liveChannel, setLiveChannel] = useState(props.live_event.data.Channel);
  const [isSearchParamsReady, setIsSearchParamsReady] = useState(false);
  const [paramUUID, setParamUUID] = useState("");
  const [clientUUID, setClientUUID] = useState("");
  const [player, setPlayer] = useState();
  const [playerType, setPlayerType] = useState(
    props.live_event.data.Player_type
  );
  const [padding, setPadding] = useState({});
  const [isPlayerReady, setIsPlayerReady] = useState(false);
  const [videoStatus, setVideoStatus] = useState({
    isPlaying: false,
    isFirstSendEvent: false,
  });
  const [sleepDuration, setSleepDuration] = useState(300);
  const [pollingDuration, setPollingDuration] = useState(60);
  const [isTracking, setIsTracking] = useState(true);

  const clientUUIDRef = useRef();
  const playerRef = useRef();
  const isPlayingRef = useRef();
  const playerTypeRef = useRef();
  const ws = useRef();

  const checkingTimerSleep = (s = 300) => {
    let start = Date.now();
    const timer = 5000;
    const timeoutLoop = () => {
      const millis = Date.now() - start;
      const seconds = Math.floor(millis / 1000);
      start = Date.now();

      if (seconds > s) {
        console.log(`Sleeping Duration : ${seconds}s`);
        console.log("Long Sleep!");
        window.location.reload();
      }
      setTimeout(timeoutLoop, timer);
    };
    timeoutLoop();
  };

  const createWS = () => {
    ws.current = new WebSocket(props.ws);
    ws.current.onmessage = e => {
      const data = JSON.parse(e.data);
      if (data.evuuid !== eventUUID) {
        return;
      }
      changePlayerType(data.playerType);
      fetchLiveEvent();
    };

    ws.current.onerror = e => console.log("WebSocket error: " + e);
    ws.current.onopen = e => {
      const dataPlayer = { action: "subscribe", topic: "player" };
      ws.current.send(JSON.stringify(dataPlayer));
    };
    return () => ws.current.close();
  };

  const createServerSideEvents = () => {
    const evtSource = new EventSource(props.live_scheduler);

    evtSource.onopen = function () {
      console.log("Connection to server opened.");
    };

    evtSource.onmessage = function (e) {
      const data = JSON.parse(e.data);
      if (data.eventUUID === eventUUID && data.type === "update") {
        changePlayerType(data.playerType);
        fetchLiveEvent();
      }
    };

    evtSource.onerror = function (e) {
      console.log(e);
    };

    return () => evtSource.close();
  };

  const changePlayerType = type => {
    if (playerTypeRef.current !== type) {
      try {
        const oldPlayer = document.getElementById("amazon-ivs-videojs");
        if (oldPlayer) {
          videojs(oldPlayer).dispose();
        }
        setIsPlayerReady(false);
      } catch (e) {
        console.log(e);
      }

      setPlayerType(type);
    }

    if (type === "poster") {
      setVideoStatus({
        ...videoStatus,
        isPlaying: false,
      });
    }
  };

  const fetchLiveEvent = () => {
    //fetch survapi
    axios({
      url: props.domain + "/ex/events/" + props.uuid + "?embed=channel",
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + props.token,
        "Content-Type": "application/json",
        Pragma: "no-cache",
      },
    })
      .then(function (res) {
        const data = res.data.data;
        setLiveEvent(data);
        setLiveChannel(data.Channel);
        changePlayerType(data.Player_type);
      })
      .catch(error => {
        console.log("Error: " + error);
      });
  };

  const setCookie = (cname, cvalue, lifetimeInHours) => {
    try {
      const d = new Date();
      // cookie lifetime needs to be converted to milliseconds
      d.setTime(d.getTime() + lifetimeInHours * 60 * 60 * 1000);
      const expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    } catch (e) {
      console.log("Error cannot set the cookie");
      console.log(e);
    }
  };

  const generateUuid = () => {
    let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case "x":
          chars[i] = Math.floor(Math.random() * 16).toString(16);
          break;
        case "y":
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join("");
  };

  const checkUUID = () => {
    const cookieValue = (document.cookie.match(
      "(^|; )" + eventUUID + "=([^;]*)"
    ) || 0)[2];

    const isPatternOk =
      /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/.test(
        cookieValue
      );

    if (!isPatternOk) {
      // Create a new UUID
      // console.log("Generating a new UUID");
      const gClientUUID = generateUuid();
      setClientUUID(gClientUUID);
      // Saving the UUID in a cookie
      setCookie(eventUUID, clientUUID, uuidCookieLifetime);
    } else {
      // console.log("Using existing UUID");
      setClientUUID(cookieValue);
    }
  };

  const getSerchParams = () => {
    //parameta
    const url = new URL(window.location);
    const searchParams = new URLSearchParams(url.search.slice(1));

    if (searchParams.has("autoplay")) {
      const valueString = searchParams.get("autoplay");
      const value = valueString === "true";

      setPlayerOptions({
        ...playerOptions,
        autoplay: value,
        muted: value,
      });
    }

    if (searchParams.has("uuid")) {
      const value = searchParams.get("uuid");
      if (value) {
        setParamUUID(value);
      }
    }

    // Padding-top set 0 to fill in iframe.
    if (searchParams.has("padding")) {
      const value = searchParams.get("padding");
      if (value === "false" || value === "0") {
        setPadding({ paddingTop: 0 });
      }
    }

    if (searchParams.has("sleep")) {
      const value = searchParams.get("sleep");
      if (!isNaN(value)) {
        const numValue = Number(value);
        setSleepDuration(numValue);
      }
    }

    if (searchParams.has("polling")) {
      const value = searchParams.get("polling");
      if (!isNaN(value)) {
        const numValue = Number(value);
        setPollingDuration(numValue);
      }
    }

    if (searchParams.has("tracking")) {
      const valueString = searchParams.get("tracking");

      if (valueString === "false") {
        setIsTracking(false);
      } else {
        setIsTracking(true);
      }
    }

    setIsSearchParamsReady(true);
  };

  const sendBeaconToAnalytics = () => {
    // NB The beacon is sent if the video is playing and tracking parameter is true
    if (isPlayingRef.current && isTracking) {
      const uuid = paramUUID !== "" ? paramUUID : clientUUIDRef.current;
      const URL = analyticsDomain + "/" + eventUUID + "?uuid=" + uuid;
      //console.log("Beacon...")
      axios({
        method: "POST",
        url: URL,
        timeout: 3000,
        headers: {
          Authorization: "Bearer " + props.token,
          "Content-Type": "application/json",
        },
      })
        .then(res => {
          // console.log("Beacon sent");
        })
        .catch(error => {
          // console.log("Beacon not sent");
          console.log("Error: " + error);
        });
    }
  };

  const sendPlayEvent = () => {
    if (isTracking) {
      const uuid = paramUUID !== "" ? paramUUID : clientUUIDRef.current;
      const URL = props.domain + "/ex/play_event";
      axios({
        method: "POST",
        url: URL,
        timeout: 3000,
        headers: {
          Authorization: "Bearer " + props.token,
          "Content-Type": "application/json",
        },
        data: {
          UUID: uuid,
          EventUUID: eventUUID,
        },
      })
        .then(res => {
          // console.log("play event sent");
        })
        .catch(error => {
          // console.log("Beacon not sent");
          console.log("Play Event Error: " + error);
        });
    }
  };

  //player init
  const ivsPlayerInit = options => {
    let playback_url = liveChannel.Custom_live_url;

    // Register Amazon IVS as playback technology for Video.js
    registerIVSTech(videojs);
    registerIVSQualityPlugin(videojs);

    // Initialize player
    let player = videojs(
      "amazon-ivs-videojs",
      {
        techOrder: ["AmazonIVS"],
        ...options,
      },
      () => {
        // Play stream
        player.enableIVSQualityPlugin();
        player.src([
          {
            type: "application/x-mpegURL",
            src: playback_url,
          },
        ]);
      }
    );

    player.on(["ended", "error", "pause"], e => {
      setVideoStatus({
        ...videoStatus,
        isPlaying: false,
      });
      //console.log("Playing : false " + e.type);
    });

    player.on(["playing", "play"], e => {
      setVideoStatus({
        ...videoStatus,
        isPlaying: true,
      });
      //console.log("Playing : true " + e.type);
    });

    //Sending the first beacon without waiting for n minutes
    player.one(["playing"], e => {
      setVideoStatus({
        ...videoStatus,
        isPlaying: true,
        isFirstSendEvent: true,
      });
    });

    player.on("ready", e => {
      window.parent.postMessage({ playerReady: true }, "*");
    });

    setPlayer(player);
  };

  const eventMessage = e => {
    // console.log("[eventMessage] origin:" + e.origin)
    // console.log("[eventMessage] data:" + e.data)

    if (!e.data) {
      return;
    }

    // Check the origin if needed.
    if (e.origin.indexOf("xxx.jp") == -1) {
      // console.log(e.origin + " Not allowed");
      // return;
    }

    let event = "";
    let value = "";
    try {
      event = JSON.parse(e.data).playerEvent;
      value = JSON.parse(e.data).playerEventValue;
    } catch (e) {
      return false;
    }

    switch (event) {
      case "mute":
        playerRef.current.muted(true);
        break;
      case "unmute":
        playerRef.current.muted(false);
        break;
      case "pause":
        playerRef.current.pause();
        break;
      case "play":
        playerRef.current.play();
        break;
      case "volume":
        // value should be 0(off) - 1.0(max), 0.5 is half way.
        playerRef.current.volume(value);
        break;
      default:
        console.log("[eventMessage] The event is NOT supported.");
        break;
    }
  };

  /*
    DidMount
  */
  useEffect(() => {
    // Sending Beacon to Real Time Analytics every n minutes
    // Call the live analytics API every n minutes
    const interval = setInterval(() => {
      sendBeaconToAnalytics();
    }, props.analytics_beacon_delay);

    // websocket
    createWS();

    // Server Side Events
    if (props.live_scheduler) {
      createServerSideEvents();
    }

    // Client UUID
    checkUUID();

    // SerchParams
    getSerchParams();

    //postMessage
    window.addEventListener("message", eventMessage);

    return () => {
      clearInterval(interval);
    };
  }, []);

  /*
    clientUUID Update
  */
  useEffect(() => {
    clientUUIDRef.current = clientUUID;
  }, [clientUUID]);

  /*
    isPlaying Update
  */
  useEffect(() => {
    isPlayingRef.current = videoStatus.isPlaying;
  }, [videoStatus.isPlaying]);

  /*
    player Update
  */
  useEffect(() => {
    playerRef.current = player;
  }, [player]);

  /*
    playerType Update
  */
  useEffect(() => {
    playerTypeRef.current = playerType;
  }, [playerType]);

  /*
    Judgment isPublic
  */
  useEffect(() => {
    // isPublic
    if (!liveEvent.Privacy) {
      setIsPublic(true);
    } else {
      setIsPublic(false);
    }
  }, [liveEvent.Privacy]);

  /*
    After GetSearchParams
  */
  useEffect(() => {
    let pollingInterval;

    if (isSearchParamsReady) {
      // If OS (PC) is sleepd for n seconds, Window is reloaded.
      const sleepTime = sleepDuration > 0 ? sleepDuration : 300;
      checkingTimerSleep(sleepTime);

      // Fetch EventAPI by polling every n minutes
      // Avoid risks for websocket failure
      const pollingTimeSeconds = pollingDuration > 0 ? pollingDuration : 60;
      const pollingTime = pollingTimeSeconds * 1000;
      pollingInterval = setInterval(() => {
        fetchLiveEvent();
      }, pollingTime);
    }

    return () => {
      clearInterval(pollingInterval);
    };
  }, [isSearchParamsReady]);

  /*
    aws-ivs-player
  */
  useEffect(() => {
    if (
      !isPublic ||
      playerType !== "player" ||
      !isSearchParamsReady ||
      isPlayerReady ||
      !liveChannel.Custom_live_url
    ) {
      return;
    }
    let scripts = [
      {
        name: "ivs-videojs-integraion",
        src: "https://player.live-video.net/1.7.0/amazon-ivs-videojs-tech.min.js",
        ref: "",
      },
      {
        name: "ivs-videojs-quality",
        src: "https://player.live-video.net/1.7.0/amazon-ivs-quality-plugin.min.js",
        ref: "",
      },
    ];

    // when all scripts are loaded, videojs play.
    let loadCounter = 0;
    let maxLoadedCount = scripts.length;

    scripts.forEach((scr, i) => {
      const script = document.createElement("script");
      script.src = scr.src;
      script.defer = true;
      document.body.appendChild(script);
      scripts[i].ref = script;

      script.addEventListener("load", () => {
        loadCounter++;
        if (loadCounter === maxLoadedCount) {
          ivsPlayerInit(playerOptions);
          setIsPlayerReady(true);
        }
      });
    });
    return () => {
      scripts.forEach(scr => {
        document.body.removeChild(scr.ref);
      });
    };
  }, [playerType, isPublic, isSearchParamsReady, liveChannel.Custom_live_url]);

  /*
    send Tracking API
  */
  useEffect(() => {
    if (!videoStatus.isFirstSendEvent) {
      return;
    }

    sendBeaconToAnalytics();
    sendPlayEvent();

    setVideoStatus({
      ...videoStatus,
      isFirstSendEvent: false,
    });
  }, [videoStatus.isFirstSendEvent]);

  return isPublic ? (
    playerType === "player" ? (
      <div className="wrapper">
        <video
          id="amazon-ivs-videojs"
          className="video-js vjs-default-skin vjs-big-play-centered"
          playsInline
          preload="yes"
          style={padding}
        ></video>
      </div>
    ) : (
      <img
        style={{ width: "100%", height: "auto" }}
        src={liveEvent.Poster_url}
      ></img>
    )
  ) : (
    <h1 className="title permission-message">
      Sorry, this video is private.
      <br />
      この動画は非公開です。
    </h1>
  );
};

export default Ivs;
